import type { IntlShape } from 'react-intl';

import type { WorkspaceListItem } from 'src/apiClients/queries';
import type { DataTableColDef, DataTableRow } from 'src/components/data-table/DataTable.types';
import {
    createAccessFilterOptions,
    createAccessLabel,
    createDateTimeFormatter,
    createNaFallback,
    createStateFilterOptions,
    createStateLabel,
} from 'src/utils/table-formatters';

import { workspaceTableI18n } from './workspace-table-formatters.i18n';

/** Shared row projection for workspace tables. */
export const mapWorkspaceRow = (workspace: WorkspaceListItem): DataTableRow => ({
    id: workspace.id,
    name: workspace.name,
    description: workspace.description,
    access: workspace.access,
    state: workspace.state,
    createdAt: workspace.createdAt,
});

/** Column definitions shared across all workspace tables. */
export const createWorkspaceColumns = (intl: IntlShape): DataTableColDef[] => {
    const naFallback = createNaFallback(intl);
    const accessLabel = createAccessLabel(intl);
    const stateLabel = createStateLabel(intl);
    const dateTimeFormatter = createDateTimeFormatter(intl);
    return [
        {
            field: 'name',
            headerName: intl.formatMessage(workspaceTableI18n.name),
            flex: 1,
            minWidth: 150,
            wrapText: true,
            valueFormatter: naFallback,
        },
        {
            field: 'description',
            headerName: intl.formatMessage(workspaceTableI18n.description),
            flex: 1,
            minWidth: 150,
            wrapText: true,
            valueFormatter: naFallback,
        },
        {
            field: 'access',
            headerName: intl.formatMessage(workspaceTableI18n.access),
            width: 90,
            filterOptions: createAccessFilterOptions(intl),
            valueFormatter: accessLabel,
        },
        {
            field: 'state',
            headerName: intl.formatMessage(workspaceTableI18n.status),
            width: 100,
            filterOptions: createStateFilterOptions(intl),
            valueFormatter: stateLabel,
        },
        {
            field: 'createdAt',
            headerName: intl.formatMessage(workspaceTableI18n.createdAt),
            width: 150,
            valueFormatter: dateTimeFormatter,
        },
    ];
};
